import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { getCourseComponents } from '../actions/getCourseComponents';

type GetCourseComponentsParams = {
  sourcedIds?: string[];
};

export const getCourseComponentsQueryKey = (
  params: GetCourseComponentsParams
) => ['course-components', params.sourcedIds, params];

export const getCourseComponentsQueryOptions = (
  params: GetCourseComponentsParams
) =>
  queryOptions({
    queryKey: getCourseComponentsQueryKey(params),
    staleTime: 0, // always fetch fresh data

    placeholderData: keepPreviousData, // don't have 0 rows flash while changing pages/loading next page
    queryFn: async () => {
      const filter = params.sourcedIds
        ? `sourcedId='${params.sourcedIds.join("' OR sourcedId='")}'`
        : '';

      const response = await getCourseComponents({
        data: {
          filter,
        },
      });

      return response.data;
    },
  });

export const useGetCourseComponents = (params: GetCourseComponentsParams) =>
  useQuery(
    getCourseComponentsQueryOptions({
      sourcedIds: params.sourcedIds,
    })
  );
